import React from 'react';
import {
    Grid,
    Table,
    TableRow,
    TableHeaderCell,
    TableCell,
    Checkbox
} from 'semantic-ui-react';

// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';

export default class PrintSprayWorksheetSignOff extends React.PureComponent {
    render(): React.ReactElement {
        return (
            <div className="print-worksheet-page-section">
                <ResponsiveTable>
                    <Table
                        basic="very"
                        className="basic-table || sign-off-table"
                        unstackable
                    >
                        <Table.Header>
                            <TableRow>
                                <TableHeaderCell>Start time</TableHeaderCell>
                                <TableHeaderCell>End time</TableHeaderCell>
                                <TableHeaderCell>
                                    Surplus disposed
                                </TableHeaderCell>
                                <TableHeaderCell>Equip. washed</TableHeaderCell>
                                <TableHeaderCell>
                                    Operator sign.
                                </TableHeaderCell>
                                <TableHeaderCell>Manager sign.</TableHeaderCell>
                            </TableRow>
                        </Table.Header>
                        <Table.Body>
                            <TableRow>
                                {/* Empty cells as the user should print and write it down */}
                                <TableCell>
                                    <span aria-hidden className="empty-cell">
                                        Empty text
                                    </span>
                                </TableCell>
                                <TableCell>
                                    <span aria-hidden className="empty-cell">
                                        Empty text
                                    </span>
                                </TableCell>
                                <TableCell>
                                    <span aria-hidden className="empty-cell">
                                        Empty text
                                    </span>
                                </TableCell>
                                <TableCell>
                                    <span aria-hidden className="empty-cell">
                                        Empty text
                                    </span>
                                </TableCell>
                                <TableCell>
                                    <span aria-hidden className="empty-cell">
                                        Empty text
                                    </span>
                                </TableCell>
                                <TableCell>
                                    <span aria-hidden className="empty-cell">
                                        Empty text
                                    </span>
                                </TableCell>
                            </TableRow>
                        </Table.Body>
                    </Table>
                </ResponsiveTable>
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <span className="written-details-section">
                                Weather:
                                <Checkbox
                                    label="Calm"
                                    className="weather-checkbox"
                                />
                                <Checkbox
                                    label="Breezy"
                                    className="weather-checkbox"
                                />
                                <Checkbox
                                    label="Windy"
                                    className="weather-checkbox"
                                />
                                <Checkbox
                                    label="Dry"
                                    className="weather-checkbox"
                                />
                                <Checkbox
                                    label="Showery"
                                    className="weather-checkbox"
                                />
                                <Checkbox
                                    label="Rain"
                                    className="weather-checkbox"
                                />
                            </span>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <span className="written-details-section">
                                Additional comments:
                            </span>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}
